import type { AnyLocaleType } from './locale-type.js';
import {
  buildTranslator,
  type FormatterCtor,
  type ITranslator,
  type ITranslatorOptions,
} from './translator-core.js';

export type { ITranslator, ITranslatorOptions, RichArgs, TranslateFn } from './translator-core.js';

/**
 * The web entry's translator (ADR-148, concept §5.5): a message with no ICU syntax is returned as it is, a
 * message of literals, arguments and tags is run here (the first screens' areas hold only those), and anything
 * else (plural, select, number, date) goes to the formatter a chunk has registered. It imports no formatter,
 * so `intl-messageformat` (7 KB with its memoizer) is in the chunks that need it and not in the entry, whose
 * size is a budget (`launch-tab-boot.spec.ts`).
 */
let registered: FormatterCtor | undefined;

/** A chunk that draws plural, select, number or date messages registers the formatter before it draws. */
export function registerFormatter(formatter: FormatterCtor): void {
  registered = formatter;
}

export function createLiteTranslator(
  locale: AnyLocaleType,
  messages: unknown,
  fallback?: { locale: AnyLocaleType; messages: unknown },
  options: ITranslatorOptions = {},
): ITranslator {
  return buildTranslator(locale, messages, fallback, options, () => registered, true);
}
